module.exports = __webpack_public_path__ + "static/media/16.d1073f49.jpg";